import React from 'react';
import Header from 'components/Header';
import UserStore from 'components/UserStore';
import request from '../../../utils/agent';
import Menu from './Components/Menu';
import './Admin.scss';


export default class AdminTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userIsValid: UserStore.isLoggedIn(),
            userCData: {},
            loaded: false,
        }
    }

    // When loading the UserTemplate, lets grab all the User Data
    async componentDidMount() {
        if(!this.state.userIsValid) {
            let userIsValid = await this.getUserData();
            this.setState({userIsValid});
        }
        this.geCData();
    }

    getUserData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    UserStore.add(resp.body.user);
                    resolve(true);
                });

        });
    };

    geCData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userCData: resp.body.user.cdata,
                        loaded: true,
                    });
                    resolve(true);
                });

        });
    };


    render() {
        if(!this.state.userIsValid) {
            return null;
        }

        return (
            <div className="admin-dashboard">
                <Header />
                <div className="admin_container clearfix">
                    {this.state.loaded ?
                        <Menu
                            name={`${this.state.userCData.first_name} ${this.state.userCData.last_name}`}
                        /> :
                        <Menu
                            name=""
                        />
                    }
                    <div className="admin_content col-md-10">
                        {this.props.children}
                    </div>
                </div>
            
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Templates/Admin/index.js